export default "__VITE_ASSET__BgvHrRwh__"